import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingPath } from '@app/core/Enum/routing-path';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  showPage: boolean;
  constructor(private spinner: NgxSpinnerService, private router: Router) {}

  ngOnInit(): void {
    if (this.router.url !== '/https:') {
      this.showPage = true;
    }

    setTimeout(() => {
      this.spinner.hide();
    }, 500);
  }

  onButtonClick(): void {
    const hasBookkeeping = (() => {
      const value = localStorage.getItem('userPermission');
      if (!value) {
        return false;
      }

      try {
        const permissions = JSON.parse(value);
        if (!Array.isArray(permissions)) {
          return false;
        }

        const checkMenuTree = (items: any[]): boolean =>
          items.some((item) => {
            const name = item?.name?.toLowerCase?.();
            if (name === 'bookkeeping') {
              return true;
            }

            const subMenu = Array.isArray(item?.subMenu) ? item.subMenu : [];
            return subMenu.length > 0 && checkMenuTree(subMenu);
          });

        return checkMenuTree(permissions);
      } catch {
        return false;
      }
    })();

    this.router.navigate([hasBookkeeping ? RoutingPath.Dashboard : RoutingPath.OpeningBalance]);
  }
}
